/* eslint-disable @typescript-eslint/no-explicit-any */
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
export function debounce(
// FIXME: make this a generic function
// eslint-disable-next-line @typescript-eslint/ban-types
func, wait = 166) {
    let timeout;
    const debounced = (...args) => {
        const later = () => {
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
    debounced.clear = () => {
        clearTimeout(timeout);
    };
    return debounced;
}
export const generateId = (prefix = "id") => `${prefix}-${Math.random().toString(32).substring(2, 6)}`;
//# sourceMappingURL=utils.js.map